import React, { useState } from "react";
import { Form, Select, Transfer, Cascader } from "antd";
import { FormComponentProps } from "antd/lib/form";
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 10 },
    lg: { span: 10 },
    xl: { span: 5 },
    xxl: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
    md: { span: 24 },
    lg: { span: 14 },
    xl: { span: 14 },
    xxl: { span: 14 },
  },
};

// const mockData: any = [];
// for (let i = 0; i < 20; i++) {
//   mockData.push({
//     key: i.toString(),
//     title: `content${i + 1}`,
//     description: `description of content${i + 1}`,
//     // disabled: i % 3 < 1,
//   });
// }

const data = [
  {
    key: "0",
    title: "立邦",
  },
  {
    key: "1",
    title: "雪花",
  },
  {
    key: "2",
    title: "大搜车",
  },
  {
    key: "3",
    title: "中国黄金",
  },
  {
    key: "4",
    title: "牧原",
  },
  {
    key: "5",
    title: "尚信",
  },
  {
    key: "6",
    title: "永荣",
  },
];

const oriTargetKeys = data
  .filter((item) => +item.key % 3 > 1)
  .map((item) => item.key);

const options = [
  {
    value: "互联网银行",
    label: "互联网银行",
    children: [
      {
        value: "微众银行",
        label: "微众银行",
      },
    ],
  },
  {
    value: "商业银行",
    label: "商业银行",
    children: [
      {
        value: "华润银行",
        label: "华润银行",
      },
    ],
  },
];

interface Props extends FormComponentProps {}

const index = (props: Props) => {
  const [targetKeys, setTargetKeys] = useState(undefined);
  const [selectedKeys, setSelectedKeys] = useState<any>([]);
  const [disabled, setDisabled] = useState(false);

  const selectedData = (selectedKeys) => {
    let arr: any = [];
    for (let i = 0; i < selectedKeys.length; i++) {
      let r: any = data[selectedKeys[i]].title;
      arr.push(r);
    }
    return arr;
  };

  const { getFieldDecorator } = props.form;

  const handleChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys);
    const selectFund = selectedData(nextTargetKeys);
    sessionStorage.setItem("propertySelected", selectFund);
  };

  function onChange(value) {
    const res = value.slice(-1);
    console.log(res);
    sessionStorage.setItem("fundSelected", res);
  }

  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const handleScroll = (direction, e) => {
    console.log("direction:", direction);
    console.log("target:", e.target);
  };

  const handleDisable = (disabled) => {
    setDisabled(disabled);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      if (!err) {
        console.log(values);
      }
    });
  };

  return (
    <Form onSubmit={handleSubmit} className="login-form" {...formItemLayout}>
      <h1>资产配对</h1>
      <Form.Item label="选择资金方">
        {getFieldDecorator("userName", {
          rules: [{ required: true, message: "请输入用户名!" }],
        })(
          <Cascader
            options={options}
            onChange={onChange}
            placeholder="请选择"
            style={{ width: "400px" }}
          />
        )}
      </Form.Item>
      <Form.Item label="选择资产方">
        {getFieldDecorator("password", {
          rules: [{ required: true, message: "请输入密码!" }],
        })(
          <div>
            <Transfer
              dataSource={data}
              titles={["可选", "已选"]}
              targetKeys={targetKeys}
              selectedKeys={selectedKeys}
              onChange={handleChange}
              onSelectChange={handleSelectChange}
              onScroll={handleScroll}
              render={(item) => item.title}
              // disabled={disabled}
            />
            {/* <Switch
              unCheckedChildren="disabled"
              checkedChildren="disabled"
              checked={disabled}
              onChange={handleDisable}
              style={{ marginTop: 16 }}
            /> */}
          </div>
        )}
      </Form.Item>
    </Form>
  );
};

export default Form.create()(index);
